<div class="bc-chat-widget column-flex-container bc-work-item-theme {{chatThemeClass}}">
  <work-widget-header [chat]="chat"
                      *ngIf="isMultiLane && chat"
                      class="bc-panel column-flex-fix"
                      [attr.data-automation-id]="'bc-chat-widget-header'"
                      [workItem]="workItem"
                      [title]="visitor?.fields.name?.value || visitor?.fields.email?.value"
                      [visitor]="visitor"></work-widget-header>

  <div class="chat-widget-content column-flex-grow multilane-wrapper panel-shadow-wrapper" *ngIf="chat">
    <div class="multilane-item multilane-item-2 bc-work-lane"
         *ngIf="showActiveAssistPanel">
      <div class="bc-panel bc-panel-maxh">
        <div class="close-session" *ngIf="showRemoteControlPanel">
          <app-loading></app-loading>
          <svg-icon icon="x" (click)="stopRCSession()"></svg-icon>
        </div>
        <app-remote-control-panel *ngIf="showRemoteControlPanel"
                                  [workItem]="workItem"></app-remote-control-panel>

        <app-assisted-browsing-panel *ngIf="showAssistedBrowsingPanel"
                                     [chat]="chat" (close)="cancelAssistedBrowsing()"></app-assisted-browsing-panel>
      </div>
    </div>

    <div class="multilane-item multilane-item-1 bc-work-lane"
         [ngClass]="{ 'col-md-12 col-lg-12': !isExpandedMode(), 'col-md-4 col-lg-4': isExpandedMode() }">
      <div class="bc-panel-maxh">
        <work-widget-header [chat]="chat" *ngIf="!isMultiLane" [workItem]="workItem" [title]="visitor?.fields.name?.value || visitor?.fields.email?.value"></work-widget-header>

        <app-chat-box [chat]="chat" [cannedMessageRequest]="cannedMessage" [isCannedMessagePanelOpen]="isCannedMessagePanelOpen" [workItem]="workItem" [isDiscussionPanelOpened]="isDiscussionPanelOpened()" [isNanorepVisible]="doesCustomerUseNanorep()" tabindex="-1"></app-chat-box>
      </div>
    </div>

    <div
      class="multilane-item multilane-item-1 bc-work-lane cm-lane-wrapper"
      [attr.data-automation-id]="'SMART_ADVISOR'"
      *ngIf="isSmartAdvisorPanelVisible()"
      [ngClass]="{ 'col-xs-12 col-sm-12 col-md-4 col-lg-4 bc-middle-lane': isExpandedMode() }"
    >
      <smart-advisor
        *ngIf="smartAdvisor2Enabled"
        [chat]="chat"
        [chatIsEnded]="chat?.isEnded()"
        [workItemId]="workItem.id"
        [workItemType]="workItem.type"
        [isOpened]="isExpandedMode() || (isCannedMessagePanelOpen && isSmartAdvisor)"
        [isExpanded]="isExpandedMode()"
        [nanorepConfigId]="workItem.NanorepConfigID"
        [visitor]="visitor"
        (panelClose)="onNanorepPanelClose()"
      ></smart-advisor>
      <nanorep-panel
        *ngIf="!smartAdvisor2Enabled"
        [workItemId]="workItem.id"
        [workItemType]="workItem.type"
        [isOpened]="isExpandedMode() || (isCannedMessagePanelOpen && isSmartAdvisor)"
        [isExpanded]="isExpandedMode()"
        [nanorepConfigId]="workItem.NanorepConfigID"
        [visitor]="visitor"
        (panelClose)="onNanorepPanelClose()"
      ></nanorep-panel>
    </div>
    <div class="multilane-item multilane-item-1 bc-work-lane cm-lane-wrapper"
         [attr.data-automation-id]="'CANNED_MESSAGES'"
         *ngIf="isFeatureConfigLoaded() && isChatActive() && isCannedMessagesLaneVisible"
         [ngClass]="{ 'col-xs-12 col-sm-12 col-md-4 col-lg-4 bc-middle-lane': isExpandedMode() }">
      <app-canned-message-panel
        *ngIf="!isSmartAdvisor || isExpandedMode()"
        [cannedMessageRequest]="cannedMessage"
        [workItemId]="workItem.id"
        [isOpened]="isExpandedMode() || isCannedMessagePanelOpen"
        [isExpanded]="isExpandedMode()"
        [isCannedMessagesTabActive]="isCannedMessagesTabActive"
        [isCustomTabActive]="isCustomTabActive"
      >
      </app-canned-message-panel>
    </div>

    <div *ngIf="isDiscussionsVisible()" class="multilane-item multilane-item-1 bc-work-lane">
      <app-discussions
        [workItemIsEnded]="workItem.isEnded"
        [isTransferButtonDisabled]="workItem.hasActiveAssistedSession"
        [workItemId]="workItem.id"
        [workItemType]="workItem.type">
      </app-discussions>
    </div>

    <div class="multilane-item multilane-item-1 bc-work-lane"
         [attr.data-automation-id]="'VISITOR_INFO_PANEL'"
         *ngIf="isExpandedMode() && isVisitorInfoLaneVisible">
      <app-detailed-data [workItemId]="workItem.id" [workItemType]="workItem.type" class="bc-panel" [isNotAvailableDataHidden]="true"></app-detailed-data>
    </div>

    <div class="multilane-item multilane-item-1 bc-work-lane"
         *ngIf="isExpandedMode() && isVisitorHistoryLaneVisible">
      <div class="history-wrapper">
        <app-assignment-history class="bc-panel"
                                *ngIf="hasAssignmentHistoryPermission && chat"
                                [chatId]="chat.ChatID"
                                [isItemClosed]="!!chat.Closed"
                                [attr.data-automation-id]="'ASSIGNMENT_HISTORY_PANEL'">
        </app-assignment-history>
        <app-visitor-history class="bc-panel"
                             *ngIf="chat"
                             [chatId]="chat.ChatID"
                             [attr.data-automation-id]="'VISITOR_HISTORY_PANEL'">
        </app-visitor-history>
      </div>
    </div>

    <ng-container *ngFor="let integration of integrationWorkItemLanes">
      <div class="multilane-item multilane-item-{{ integration.width }} integration-panel bc-work-lane bc-panel"
           [attr.data-integration-id]="integration.id"
           [attr.data-automation-id]="integration.name"
           *ngIf="integration.visible && isExpandedMode()">
        <div *ngIf="!isSalesforceIntegration(integration)" class="bc-panel-header integration-panel-header">
          <span class="bc-panel-header-text">{{ integration.name }}</span>

          <button class="refresh pull-right" *ngIf="isEmbeddedIntegration(integration)" (click)="reloadIFrameUrlFromServer(integration)" [title]="'bcChatWidget.refresh' | translate">
            <svg-icon icon="refresh"></svg-icon>
          </button>
        </div>

        <div class="frame-container" *ngIf="isEmbeddedIntegration(integration)">
          <app-refreshable-frame [src]="integration.src" (onSrcRefresh)="reloadIFrameUrlFromServer(integration)"></app-refreshable-frame>
        </div>
        <div class="salesforce-lane-container" *ngIf="isSalesforceIntegration(integration)">
          <app-salesforce-lane [chatId]="chat.ChatID"></app-salesforce-lane>
        </div>
      </div>
    </ng-container>
  </div>
  <app-loading *ngIf="!chat" heading="bcLoading.loadingText"></app-loading>
</div>
